import { useQuery } from '@tanstack/react-query';
import { targetsApi } from '../api/targetsApi';

/** GET /api/eraf/gateway/targets — 전체 서비스 대상 타겟 + 최근 헬스 (#621). */
export function useTargetsQuery() {
  return useQuery({
    queryKey: ['gateway', 'targets'],
    queryFn: () => targetsApi.list(),
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
}
